import {StockInformationModel} from "../domain/stockInformationModel";

type BackOrderModelType = Pick<
    StockInformationModel,
    "leadOut" | "isBackOrderable"
>;

export class BackOrderModel {
    private _model: BackOrderModelType;

    constructor(model: BackOrderModelType) {
        this._model = model;
    }

    get leadOut() {
        return this._model.leadOut;
    }

    get showMoreExpectedMessage(){
        return this._model.isBackOrderable;
    }

    static create(model: StockInformationModel) {
        return new BackOrderModel(model);
    }
}
